








































import Vue from 'vue';

import RemoteContentPresenter from '@/components/partials/remoteContent/RemoteContentPresenter.vue';

import { acceptLegalDocs } from '@/queries/user';
import { LegalDocCode } from '@/enums/user/LegalDocCode';
import { LegalDocStatus } from '@/enums/user/LegalDocStatus';
import { getUrlWithLocale } from './helper/LegalDocHelper';

export default Vue.extend({
  name: 'TermsOfServiceModal',
  components: {
    RemoteContentPresenter,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    informationMode: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String as () => LegalDocStatus,
    },
  },
  data(): {
    saving: boolean;
    documentLoaded: boolean;
    accepted: boolean;
  } {
    return {
      saving: false,
      documentLoaded: false,
      accepted: false,
    };
  },
  computed: {
    modalTitle(): string {
      return this.status === LegalDocStatus.UPDATE_NOT_ACCEPTED
        ? Vue.i18n.translate('LegalDocs_UpdateTitle', {
          docName: Vue.i18n.translate('LegalDocs_TermsOfService')!,
        })!
        : Vue.i18n.translate('LegalDocs_TermsOfService')!;
    },
    termsUrl(): string | undefined {
      return getUrlWithLocale(process.env.TERMS_OF_SERVICE_URL, Vue.i18n.locale());
    },
    acceptDisabled(): boolean {
      return !this.documentLoaded
        || !this.accepted
        || this.saving;
    },
  },
  methods: {
    async acceptAgreement() {
      try {
        this.saving = true;
        await acceptLegalDocs(this.$apollo, [LegalDocCode.TERMS_OF_SERVICE]);
      } catch (e) {
        this.$awn.alert(
          Vue.i18n.translate('LegalAgreement_SavingFailed')!,
        );
      } finally {
        this.saving = false;
      }
    },
    termsLoadedSuccessfully() {
      this.documentLoaded = true;
    },
    termsLoadingFailed() {
      this.documentLoaded = false;
    },
  },
});
